import { 
  NewConfigurationFormModel, 
} from './new-configuration.model';

import { 
  BaseClass,
  dropProps,
} from 'src/api/models/Base/base.class';

import { InputModel } from 'src/api/models/Form/InputField/input.model';

import { InputClass } from 'src/api/models/Form/InputField/input.class';

import { newConfigurationFormData } from './new-configuration.data';
import { SelectFieldClass, SelectFieldModel } from '../../Form';

export class NewConfigurationClass extends BaseClass<NewConfigurationFormModel> implements NewConfigurationFormModel {
  get name(): InputModel {
    return dropProps(this.props.name, new InputClass(this.props.name)); 
  }
  get pricingsAccessories(): SelectFieldModel {
    return dropProps(this.props.pricingsAccessories, new SelectFieldClass(this.props.pricingsAccessories)); 
  }
  get pricingsWashbasin(): SelectFieldModel {
    return dropProps(this.props.pricingsWashbasin, new SelectFieldClass(this.props.pricingsWashbasin)); 
  }
}

export const newConfigurationFormValues = () => newConfigurationFormData && dropProps(
  newConfigurationFormData(), new NewConfigurationClass(newConfigurationFormData())
);
